import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=68bd9d68&scoped=true"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=68bd9d68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd9d68",
  null
  
)

export default component.exports